module.exports = "<app-header></app-header>\n<div id=\"logoutContainer\"> \n                <h4>Log Out</h4> \n                <h5>You have been logged out of this application.</h5> \n                <p>To completely log out of Single Sign On, please close your browser.</p> \n        </div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/logout/logout.component.html
// module id = ./src/app/logout/logout.component.html
// module chunks = main